export const INIT_CONTACTS_SUCCESSFULLY = "contacts.INIT_CONTACTS_SUCCESSFULLY";
export const SEND_CONTACTS_LIST = "contacts.SEND_CONTACTS_LIST";
